import { ContentFragmentType } from '../Content';
import { generateTrackingIdentifier } from '../../../types/identifiers/trackingIdentifier';
import { createGuid } from '../../../api/public/utils/Guid';
export const WidgetHelper = {
    createNewWidget: (defaultValue, initialized) => createWidgetObject(createGuid(), generateTrackingIdentifier(), initialized, defaultValue.data, defaultValue.properties, defaultValue.type),
    buildWidget: (id, trackingIdentifier, data, properties, type) => {
        return createWidgetObject(id, trackingIdentifier, true, data, properties, type);
    },
    isWidget: (fragment) => {
        return fragment.type === ContentFragmentType.Widget;
    },
};
const createWidgetObject = (id, trackingIdentifier, initialized, data, properties, type) => {
    return {
        _id: id,
        trackingIdentifier: trackingIdentifier,
        type: ContentFragmentType.Widget,
        initialized,
        value: {
            properties: properties,
            data: data,
            type: type,
        },
    };
};
